import {ComponentProps} from "react";
import classNames from "classnames";
import {Product} from "@/entities/product";
import {useBasketAction} from "../model/useBasketAction";
import {Svg} from "@/shared/ui/Svg";
import {Button} from "@/shared/ui/Button";
import styles from "./BasketActionButton.module.scss";

type Props = Omit<ComponentProps<typeof Button>, "loading" | "children" | "onClick"> & {
    product: Product;
    productDataId?: number | null;
    iconClassName?: string;
    addText?: string;
    inBasketText?: string;
};

export const BasketActionButton = (
    {
        product,
        productDataId,
        variant,
        className,
        labelClassName,
        iconClassName,
        addText = "В корзину",
        inBasketText = "В корзине",
        ...buttonProps
    }: Props
) => {
    const {
        isInBasket,
        loading,
        handleAddToBasket,
    } = useBasketAction({
        product,
        productDataId,
    });

    const iconName = isInBasket ? "inBasket" : "addToBasket";
    const buttonText = isInBasket ? inBasketText : addText;

    const buttonClasses = classNames(
        styles.button,
        {
            [styles.inBasket]: isInBasket,
            [styles.addToBasket]: !isInBasket,
        },
        className
    );
    const labelClasses = classNames(styles.label, labelClassName);
    const iconClasses = classNames(
        styles.icon,
        {
            [styles.iconInBasket]: isInBasket,
            [styles.iconAddToBasket]: !isInBasket,
        },
        iconClassName,
    );

    return (
        <Button
            {...buttonProps}
            loading={loading}
            variant={variant}
            className={buttonClasses}
            labelClassName={labelClasses}
            onClick={handleAddToBasket}
        >
            {variant === "icon" ? <Svg id={iconName} className={iconClasses} /> : buttonText}
        </Button>
    );
};
